/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ActivePool, ActivePoolInterface } from "../ActivePool";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newActivePoolAddress",
        type: "address",
      },
    ],
    name: "ActivePoolAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_balance",
        type: "uint256",
      },
    ],
    name: "ActivePoolAssetBalanceUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_VSTDebt",
        type: "uint256",
      },
    ],
    name: "ActivePoolVSTDebtUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_assetAddress",
        type: "address",
      },
    ],
    name: "AssetAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_newBalance",
        type: "uint256",
      },
    ],
    name: "AssetBalanceUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "AssetSent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newBorrowerOperationsAddress",
        type: "address",
      },
    ],
    name: "BorrowerOperationsAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newDefaultPoolAddress",
        type: "address",
      },
    ],
    name: "DefaultPoolAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newStabilityPoolAddress",
        type: "address",
      },
    ],
    name: "StabilityPoolAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newTroveManagerAddress",
        type: "address",
      },
    ],
    name: "TroveManagerAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_newBalance",
        type: "uint256",
      },
    ],
    name: "VSTBalanceUpdated",
    type: "event",
  },
  {
    inputs: [],
    name: "GMX_TOKEN",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "NAME",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SGLP",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "VESTA_ADMIN",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "borrowerOperationsAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "collSurplusPool",
    outputs: [
      {
        internalType: "contract ICollSurplusPool",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "decreaseVSTDebt",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "defaultPool",
    outputs: [
      {
        internalType: "contract IDefaultPool",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getAssetBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getVSTDebt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "increaseVSTDebt",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "isInitialized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_vaultOwner",
        type: "address",
      },
    ],
    name: "isStaked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_vaults",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_collaterals",
        type: "uint256[]",
      },
    ],
    name: "manuallyEnterVaultsToGMXStaking",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "receivedERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "restorAdminToVesta",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_vaultOwner",
        type: "address",
      },
    ],
    name: "retryStake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "sendAsset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrowerOperationsAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_troveManagerAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_stabilityManagerAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_defaultPoolAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_collSurplusPoolAddress",
        type: "address",
      },
    ],
    name: "setAddresses",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vestaGLPStaking",
        type: "address",
      },
    ],
    name: "setVestaGLPStaking",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vestaGMXStaking",
        type: "address",
      },
    ],
    name: "setVestaGMXStaking",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "stabilityPoolManager",
    outputs: [
      {
        internalType: "contract IStabilityPoolManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_behalfOf",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "stake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "troveManagerAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vestaGLPStaking",
    outputs: [
      {
        internalType: "contract IVestaGMXStaking",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vestaGMXStaking",
    outputs: [
      {
        internalType: "contract IVestaGMXStaking",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type ActivePoolConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ActivePoolConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ActivePool__factory extends ContractFactory {
  constructor(...args: ActivePoolConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<ActivePool> {
    return super.deploy(overrides || {}) as Promise<ActivePool>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): ActivePool {
    return super.attach(address) as ActivePool;
  }
  override connect(signer: Signer): ActivePool__factory {
    return super.connect(signer) as ActivePool__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ActivePoolInterface {
    return new utils.Interface(_abi) as ActivePoolInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ActivePool {
    return new Contract(address, _abi, signerOrProvider) as ActivePool;
  }
}
